import Field from 'components/Form/Field';
import FormResult from 'components/Form/FormResult';
import KeyValue from 'components/Layout/KeyValue';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import {TeamMemberPermissions} from 'components/Navigation/NavigationTabs/Team/Member';
import SectionHeader from 'components/SectionHeader';
import Value from 'components/Value';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {Backend} from 'types/api';
import {FormFields} from 'types/utils';

import EmployeeActionButtons from './EmployeeActionButtons';
import InformationCard from './InformationCard';
import {EmployeeActions, OverviewEmployee} from './types';

export type OverviewBackendData = Backend<{
    employee: OverviewEmployee;
    employeeActions: EmployeeActions;
    navigationTabs: TeamMemberPermissions;
}>;

type OverviewFormData = FormFields<{foo: string}>;

const Overview = () => {
    const {
        data: {employee, employeeActions, navigationTabs},
    } = useBackend<OverviewBackendData>();

    const methods = useForm<OverviewFormData>({
        defaultValues: {},
    });

    return (
        <FormProvider {...methods}>
            <FormResult />
            <SectionHeader title={employee.name} />
            <NavigationTabs.TeamMember
                className="my-4"
                mid={employee.mid}
                selection="overview"
                {...navigationTabs}
            />
            <div className="flex">
                <InformationCard {...employee} />
            </div>
            {!employee.isApiEmployee && (
                <>
                    <SectionHeader
                        hideHR={true}
                        level={2}
                        title={t`Additional Information`}
                    />
                    <KeyValue className="mt-4" id="additional-information">
                        <Field label={t`Sender Signature`} type="value">
                            <Value
                                value={{
                                    type: 'string',
                                    value: employee.sendingSignature || '-',
                                }}
                            />
                        </Field>
                        <Field label={t`License`} type="value">
                            <Value
                                value={{
                                    type: 'boolean',
                                    value: !!employee.rights.isStandard,
                                }}
                            />
                        </Field>
                        {employee.endDate && (
                            <Field label={t`End Date`} type="value">
                                <Value
                                    value={{
                                        format: 'date',
                                        type: 'date',
                                        value: new Date(employee.endDate),
                                    }}
                                />
                            </Field>
                        )}
                    </KeyValue>
                </>
            )}
            <EmployeeActionButtons mid={employee.mid} {...employeeActions} />
        </FormProvider>
    );
};

export default Overview;
